// extracted by mini-css-extract-plugin
export default {"classIcon":"_1GTmq","label":"_2zt0I","dimmedBg":"_2fgJ7"};